import { render, staticRenderFns } from "./CapsuleInputDate.vue?vue&type=template&id=4cae8e5f&scoped=true"
import script from "./CapsuleInputDate.vue?vue&type=script&lang=ts"
export * from "./CapsuleInputDate.vue?vue&type=script&lang=ts"
import style0 from "./CapsuleInputDate.vue?vue&type=style&index=0&id=4cae8e5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cae8e5f",
  null
  
)

export default component.exports